import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getFestivalSeries } from '../../redux/actions/festival-overview-api';
import TextDropdownItem from './dropdown-item';
import { FestivalOverviewAppState } from '../../classes/redux-states';
import { pushInUrlQuery } from 'react-url-query';

interface StateToProps {
    dayList: string[];
    activeDay: string;
    emptyDayList: string[];
}

interface DispatchToProps {
    getFestivalSeries: (day: string) => any;
}

type MobileDayProps = StateToProps & DispatchToProps;

export class MobileDayComponent extends React.Component<MobileDayProps, null> {
    constructor(props: MobileDayProps) {
        super(props);
        this.setDayDropdown = this.setDayDropdown.bind(this);
    }

    scrollToTop() {
        var topOfApp = document.querySelector('[data-festival-overview-page]');
        topOfApp.scrollIntoView(true);
    }

    dropdownChangeEvent(event) {
        this.scrollToTop();
        let abbreviatedDay = event.target.value.substring(0, 3).toUpperCase();
        pushInUrlQuery('day', abbreviatedDay);
        
        this.props.getFestivalSeries(event.target.value);
    }

    getDayQueryStringParam() {
        var dayQueryString = this.getURLParam("day") as string;
        return dayQueryString;
    }

    getURLParam(name) {
        var queryStringParam = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href); // gets a specific value from the location object's URL and filters out any symbols that may be in the URL
        if (queryStringParam == null) {
            return null;
        }
        else {
            return decodeURI(queryStringParam[1]) || 0;
        }
    }

    componentDidMount() {
        this.setDayDropdown();
    }

    setDayDropdown() {
        var dayDropdown = document.getElementById("dayListMobile") as HTMLSelectElement;
        var dayFromQueryString = this.getDayQueryStringParam();
        let day = '';
        if (dayFromQueryString !== null && dayFromQueryString !== '') {
            day = dayFromQueryString;
        }
        else {
            day = this.props.activeDay;
        }
        dayDropdown.value = day;
        for (var i = 0; i < dayDropdown.options.length; i++) {
            if (dayDropdown.options[i].value.substring(0, 3).toUpperCase() == day.toUpperCase()) {
                dayDropdown.selectedIndex = i;
            }
        }
    }

    componentDidUpdate() {
        this.setDayDropdown();
    }

    checkDisabled(day: string) {
        let abbreviatedDay = day.substring(0, 3).toUpperCase();
        for (var i = 0; i < this.props.emptyDayList.length; i++) {
            if (this.props.emptyDayList[i].toUpperCase() === abbreviatedDay) {
                return true;
            }
        }
        return false;
    }

    render() {
        return (
            <div className="season-overview-navigation-mobile">
                <label className="visually-hidden" htmlFor="dayListMobile">Day</label>
                <div className="season-overview-navigation-mobile-container">
                    <div className="select-container">
                    <select id="dayListMobile" className="day-list selectDropdown" defaultValue={this.props.dayList[6]} onChange={this.dropdownChangeEvent.bind(this)}>
                           {
                                this.props.dayList.map(day => <TextDropdownItem day={day} key={this.props.dayList.indexOf(day)} disabled={this.checkDisabled(day)} />)
                        }
                    </select>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {
        activeDay: state.festivalOverviewSettingsModel.currentDay,
        dayList: state.festivalOverviewSettingsModel.mobileDayList,
        emptyDayList: state.festivalOverviewSettingsModel.emptyDayList
    }
}

function mapDispatchToProps(dispatch: Dispatch<FestivalOverviewAppState>): DispatchToProps {
    return {
        getFestivalSeries: (day: string) => dispatch(getFestivalSeries(day))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileDayComponent);